import React, { useEffect, useState } from 'react';
import { StaticImage } from 'gatsby-plugin-image';

import ChevronRound from '../../../assets/icons/chevron_round';

import './sleepDisordersSection.scss';

export default function SleepDisordersSection() {
  const [sleepDisordersElements, setSleepDisordersElements] = useState(null);
  const [iActiveElement, setIActiveElement] = useState(0);

  function navigateElements(next = false) {
    if (next && iActiveElement < sleepDisordersElements.length - 1) {
      sleepDisordersElements[iActiveElement].classList.remove('active');
      sleepDisordersElements[iActiveElement + 1].classList.add('active');

      setIActiveElement(iActiveElement + 1);
    } else if (!next && iActiveElement > 0) {
      sleepDisordersElements[iActiveElement].classList.remove('active');
      sleepDisordersElements[iActiveElement - 1].classList.add('active');
      setIActiveElement(iActiveElement - 1);
    }
  }

  useEffect(() => {
    setSleepDisordersElements(document.querySelectorAll('.sleep-disorders>.container>.content>div'));
  }, []);

  return (
    <section id="sleep-disorders" className="sleep-disorders">
      <div className="container">
        <h2 className="white">
          What are&nbsp;
          <span className="salmon">sleep disorders?</span>
        </h2>
        <h6 className="white">
          Let’s not normalize poor sleep
          <span>&nbsp;— the first step is knowing what you’re up against</span>
          .
        </h6>
        <div className="navigation">
          <ChevronRound
            disabled={iActiveElement <= 0}
            dark
            onClick={() => {
              navigateElements();
              if (window.posthog) window.posthog.capture('caroussel_clicked', { section: 'conditions' });
            }}
          />
          <ChevronRound
            disabled={sleepDisordersElements && iActiveElement >= sleepDisordersElements.length - 1}
            right
            dark
            onClick={() => {
              navigateElements(true);
              if (window.posthog) window.posthog.capture('caroussel_clicked', { section: 'conditions' });
            }}
          />
        </div>
        <div className="content">
          <div className="active">
            <div>
              <StaticImage
                className="image"
                src="../../../images/index/sleep_disorder_sleep_apnea.png"
                alt=""
              />
              <h6 className="bold">Sleep Apnea</h6>
              <p>
                When the airway in your throat gets blocked or narrowed while you sleep.
                This leads to poor sleep, snoring, and fatigue.
              </p>
            </div>
            <div>
              <StaticImage
                className="image"
                src="../../../images/index/sleep_disorder_insomnia.png"
                alt=""
              />
              <h6 className="bold">Insomnia</h6>
              <p>
                When you have trouble falling asleep, staying asleep
                and do not feel refreshed throughout the day.
              </p>
            </div>
            <div>
              <StaticImage
                className="image"
                src="../../../images/index/sleep_disorder_rls.png"
                alt=""
              />
              <h6 className="bold">Restless Leg Syndrome</h6>
              <p>
                When you experience recurrent and unpleasant sensations to
                move your legs before falling asleep.
              </p>
            </div>
          </div>
          <div>
            <div>
              <StaticImage
                className="image"
                src="../../../images/index/sleep_disorder_hypersomnia.png"
                alt=""
              />
              <h6 className="bold">Hypersomnia</h6>
              <p>
                When you’re overly sleepy during the day, despite a good night’s sleep.
                This can affect your work and social life.
              </p>
            </div>
            <div>
              <StaticImage
                className="image"
                src="../../../images/index/sleep_disorder_crd.png"
                alt=""
              />
              <h6 className="bold">Circadian Rhythm Disorders</h6>
              <p>
                When your sleep routine doesn’t sync with your daily life—think
                delayed sleep phase syndrome, jet lag, or shift work...
              </p>
            </div>
            <div>
              <StaticImage
                className="image"
                src="../../../images/index/sleep_disorder_parasomnias.png"
                alt=""
              />
              <h6 className="bold">Parasomnias</h6>
              <p>
                When you have odd behaviors during sleep, like sleepwalking or night terrors.
                They disrupt your sleep and are quite unsettling.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
